<template>
  <v-footer absolute width="auto" class="d-flex justify-center">
    <div>
      <MadeWithLove/>
    </div>
  </v-footer>
</template>

<script>
import MadeWithLove from '@ulibs/unlogin/components/MadeWithLove';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, Name } from '@core/helpers/decorators';

@Component

@Components({ MadeWithLove })
export default class DynameatFooter extends Vue {
  @Name 'dynameat-footer';
}
</script>
